(function ($) {
  console.log("unitslider.js file");

  //initUnitSizeSlider();

  function initUnitSizeSlider() {
    // attempt to find unit size
    let unit_size = $(".unit-size");

    // if unit size not found, exit
    if (unit_size.length == 0) {
      return false;
    }

    // store if this is the space estimator or not
    let is_space_estimator = unit_size.hasClass("unit-size--is-space-estimator");

    // if NOT space estimator
    if (!is_space_estimator) {
      //new
      var site = $("#currentSite").val();

      console.log("location", site);

      updateMediaHawkNumber(site);

      $('[data-sites*="' + site + '"]').removeClass("hide");

      // return false;
      $('[data-sites]:not([data-sites*="' + site + '"])').addClass("hide");

      // add class to elements for this site if they have click+store available
      $('[data-sites-clickandstore*="' + site + '"]').addClass("unit-size__main-slider__carousel-cell--has-clickandstore");
      // remove class for elements for this site if they don't have click+store available
      $('[data-sites-clickandstore]:not([data-sites-clickandstore*="' + site + '"])').removeClass("unit-size__main-slider__carousel-cell--has-clickandstore");
      //newend
    }

    //Main carousel displaying unit info
    var initialIndex = $(".unit-size__main-slider .is-initial").index(".unit-size__main-slider__carousel-cell:not(.hide)");
    console.log("initinidex" + initialIndex);

    var mainSliderCarousel = $(".unit-size__main-slider").flickity({
      // options
      cellAlign: "left",
      contain: true,
      pageDots: false,
      initialIndex: initialIndex,
      cellSelector: ".unit-size__main-slider__carousel-cell:not(.hide)",
      prevNextButtons: false,
    });
    //var mainFlickityData = mainSliderCarousel.data("flickity");
    //Range slide input
    var rangeSlider = $(".unit-size__range-slider");
    var totalCells = $(".unit-size__main-slider__carousel-cell:not(.hide)").length;
    rangeSliderInit();

    function rangeSliderInit() {
      //count carousel slides
      var totalCells = $(".unit-size__main-slider__carousel-cell:not(.hide)").length;
      var newInitialIndex = $(".unit-size__main-slider .is-initial").index(".unit-size__main-slider__carousel-cell:not(.hide)");
      console.log("totalcells: " + totalCells);
      console.log("initialindex: " + newInitialIndex);
      //set range input total to = total slides -1 because range input starts at 0
      rangeSlider.attr("max", totalCells - 1);
      rangeSlider.attr("value", newInitialIndex);
      //load up rangeslider.js
      rangeSlider.rangeslider({
        update: true,
        polyfill: false,
      });
      var navLabelDataImperial = $(".unit-size__main-slider__carousel-cell.is-selected").attr("data-nav-label-imperial");
      var navLabelDataMetric = $(".unit-size__main-slider__carousel-cell.is-selected").attr("data-nav-label-metric");
      var navLabels = '<h5 class="rangeslider__handle__handle-label"><span class="data-imperial">' + navLabelDataImperial + '</span><span class="data-metric">' + navLabelDataMetric + "</span></h5>";
      $(".rangeslider__handle").empty();
      $(".rangeslider__handle").append(navLabels);
    }

    //remove loader
    $(".loader-wrap").fadeOut(100, function () {
      $(this).remove();
    });

    $(".unit-size__range-slider").addClass("unit-size__range-slider--visible");
    $(".unit-size__main-slider").addClass("unit-size__main-slider--visible");

    rangeSlider.on("input", function () {
      //get value of range input
      var value = $(this).val();
      console.log("Percent: " + value + ", totalCells: " + totalCells + ", My Value: " + value);
      // on input of range slider, set flickity main carousel to value of range
      mainSliderCarousel.flickity("select", value);
      var navLabelDataImperial = $(".unit-size__main-slider__carousel-cell.is-selected").attr("data-nav-label-imperial");
      var navLabelDataMetric = $(".unit-size__main-slider__carousel-cell.is-selected").attr("data-nav-label-metric");
      var navLabels = '<h5 class="rangeslider__handle__handle-label"><span class="data-imperial">' + navLabelDataImperial + '</span><span class="data-metric">' + navLabelDataMetric + "</span></h5>";
      $(".rangeslider__handle").empty();
      $(".rangeslider__handle").append(navLabels);
      $('[name="quote_product"]').val($(".unit-size__main-slider__carousel-cell.is-selected").attr("data-for-size")).change();
    });

    /* mainSliderCarousel.on(
      "dragEnd.flickity settle.flickity",
      function (event, index) {
        //on select of slide, set value of range slider to current slide index, had to change event to settle because select/change were fucking up causing a stack limit exceed in console
        rangeSlider.val(mainFlickityData.selectedIndex).change();
        console.log("slide settled on: " + mainFlickityData.selectedIndex);
      }
    ); */
    mainSliderCarousel.on("dragEnd.flickity settle.flickity", function (event, index) {
      var flkty = $(this).data("flickity");
      if (!flkty) return;

      rangeSlider.val(flkty.selectedIndex).change();
      console.log("slide settled on: " + flkty.selectedIndex);
    });

    /* $(".flickity-prev-next-button").on("click", function () {
      console.log("selectedindex: " + mainFlickityData.selectedIndex);
      rangeSlider.val(mainFlickityData.selectedIndex).change();
    }); */
    $(".flickity-prev-next-button").on("click", function () {
      var flkty = mainSliderCarousel.data("flickity");
      if (!flkty) return;

      console.log("selectedindex: " + flkty.selectedIndex);
      rangeSlider.val(flkty.selectedIndex).change();
    });

    /* Not in use as done now on page load

    setCurrentSiteCells();

    function setCurrentSiteCells() {
      var site = $('#currentSite').val();

      console.log('location', site);

      updateMediaHawkNumber(site);

      $('[data-sites*="' + site + '"]').removeClass('hide');

      // return false;
      $('[data-sites]:not([data-sites*="' + site + '"])').addClass('hide');

      // add class to elements for this site if they have click+store available
      $('[data-sites-clickandstore*="' + site + '"]').addClass('unit-size__main-slider__carousel-cell--has-clickandstore');
      // remove class for elements for this site if they don't have click+store available
      $('[data-sites-clickandstore]:not([data-sites-clickandstore*="' + site + '"])').removeClass('unit-size__main-slider__carousel-cell--has-clickandstore');


      var newInitialIndex = $('.unit-size__main-slider .is-initial').index('.unit-size__main-slider__carousel-cell:not(.hide)');
      console.log('new initial index'+initialIndex);
      console.log('new initial index: actual: '+newInitialIndex);
      mainSliderCarousel.flickity('reloadCells');
      mainSliderCarousel.flickity('resize');
      mainSliderCarousel.flickity('select', newInitialIndex);
      rangeSliderInit();
    }*/

    unitSizeRadioListener();

    function unitSizeRadioListener() {
      $("[name='show_size']").change(function () {
        var dimensions = $("input[name='show_size']:checked").val();

        $("body").attr("data-dimensions", dimensions);

        Cookies.set("dimensions", dimensions, { expires: 365 });
      });
    }

    sizeAndSiteListener();

    function sizeAndSiteListener() {
      $("[name='site'], [name='quote_product']:not('.no_check')").change(function () {
        // preemptive check of availability - to speed up availability check on quote page
        var site = $('[name="site"]').val();
        var productId = $('[name="quote_product"]').val();
        console.log("size and site listener");
        $.get("/wp-json/henfield_manager/v1/product_id/" + productId + "/site/" + site, function (data) {
          console.log(data);
        });
      });
    }

    function fixHiddenQuoteId() {
      var formUnitSize = $("form.unit-size");
      formUnitSize.on("submit", function (e) {
        // prevent form from submitting
        e.preventDefault();

        // set quote_product
        formUnitSize.find('[name="quote_product"]').val($(".unit-size__main-slider__carousel-cell.is-selected").attr("data-for-size"));

        // submit form
        formUnitSize.unbind("submit").submit();
      });
    }

    if (!is_space_estimator) {
      fixHiddenQuoteId();
    } else {
      space_estimator_click_handler();
    }

    size_selector_preselect();

    function space_estimator_click_handler() {
      let form = $(".unit-size");

      // the hidden field isn't initially set. using andy's code snippet here to set quote_product
      form.find('[name="quote_product"]').val($(".unit-size__main-slider__carousel-cell.is-selected").attr("data-for-size"));

      // when the button is clicked
      form.on("click", ".button", space_estimator_open_modal);
      $(".space-estimator__external-cta").on("click", space_estimator_open_modal);
    }

    function space_estimator_open_modal() {
      $("#reveal-nearest-store").foundation("open");
      return false;
    }

    /*
    function gdprConsentCheck() {
      console.log("gdprcheckfired");
      var gdprCookie = Cookies.get('henfield_gdpr_consent');
      if (typeof gdprCookie !== 'undefined') {
        if (gdprCookie == 0) {
          console.log("returned false on cookie is rejected");
          return false;
        }
        else {
          console.log("returned true on cookie is accepted");
          return true;
        }
      }
      else {
        console.log("returned true on cookie is undefined");
        $('.telephone-wrap').addClass('telephone-wrap--show'); // show the tel number
        return true;
      }
    }

    var gdprConsentResult = gdprConsentCheck();


    function updateMediaHawkNumber(site) {
      if (gdprConsentResult != false) {
        console.log('updateMediaHawkNumber for ' + site);

        var sitesObj = JSON.parse(siteData);
        $.each(sitesObj.sites, function (index, value) {
          if (value.name == site) {
            console.log('mediahawk_number', value.mediahawk_number);
            $('.mhMobile').attr('class', 'telephone-span mhMobile ' + value.mediahawk_number);
            $('.telephone-span.mhMobile a').addClass('is-old');
            var mhSrc = '//www.dynamicnumbers.mediahawk.co.uk/mhct.min.js';
            $('script[src="' + mhSrc + '"]').remove();
            !function(){var c=document.createElement("script"); c.type="text/javascript",c.async=!0,c.src="//www.dynamicnumbers.mediahawk.co.uk/mhct.min.js"; var i=document.getElementsByTagName("script")[0];
            i.parentNode.insertBefore(c,i)}();
            telController();
          }
        });
      }
    }

    // this function listens for the hediahawk tel number and updated the cookie
    function telController() {
      if (gdprConsentResult != false) {
        // console.log('telController');

        var $telSpan = $('.telephone-span.mhMobile').first();

        if ($telSpan.length == 0) {
          return false;
        }

        var $a = $telSpan.find('a:not(.from-cookie):not(.is-old)');

        // console.log('a');

        if ($a.length == 1) {
          var tel = {
            href: $a.attr('href'),
            text: $a.text()
          };
          Cookies.set('tel', tel);
          // console.log('set cookie');
          return false;
        }

        if ($a.length == 0) {
          // keep on looping if mediahawk a tag is not loaded
          setTimeout(function () {
            telController();
          }, 300, telController);
        }
      }

    }*/
  }
  /*
  // check availability
  checkAvailability();

  function checkAvailability()
  {
    $('.check-availability__btn').on('click', function (e)
    {
      e.preventDefault();

      var availabilityContainer   = $('.check-availability');
      var that                    = $(this);
      var href                    = that.attr('href');
      var site                    = that.data('site');
      var productId               = that.data('product');

      var loader = '<div class="loader-wrap"><div class="loader"><div></div><div></div><div></div>Loading...</div></div>';

      availabilityContainer.append(loader);

      $.get("/wp-json/henfield_manager/v1/product_id/" + productId + "/site/" + site)
        .done(function (data) {
          $('.loader-wrap').fadeOut(200, function(){
              processAvailabilityResults(that, data);
          });
      });

    });
  }

  function processAvailabilityResults(el, data)
  {
    console.log(data);
    // hide special offer
    //$('.special-offer').hide();
    if (data.availability == 0) {
      //low availability - trigger modal
      var popup = new Foundation.Reveal($('#reveal-availability'));
      popup.open();
    }
    else {
      var henfield_additional_booking_data = $('input[name=henfield_additional_booking_data]:checked').val();
      if (henfield_additional_booking_data.length > 0) {
        selectedBookingRadio = henfield_additional_booking_data;
      }
      var data = {
        action : "henfield_additional_booking_data",
        "booking_data" : selectedBookingRadio
      }
      $.post(adminAjax.adminAjaxUrl, data, function(){
        // alert(selectedBookingRadio);
        var bookingFormUrl = $('#booking-form-url').attr('href');
        window.location.href = bookingFormUrl;
      });
    }
  }
  */
  $(function () {
    setTimeout(initUnitSizeSlider, 500);
    console.log("size selector reloaded");
  });
})(jQuery); // Fully reference jQuery after this point.

// unitSizeRadioSetter - run asap dont wait for load
var dimensions = Cookies.get("dimensions");
if (dimensions !== "metric") {
  dimensions = "imperial";
}
jQuery('.unit-toggle [value="' + dimensions + '"]').prop("checked", true);

function size_selector_preselect() {
  const params = new URLSearchParams(window.location.search);
  if (params.get("sizecode") != null) {
    select_exact_or_closest_product_size(params.get("site"), params.get("sizecode"), true);
  }
}

/**
 * this helper function attempts to select a certain size, else it'll look for the
 * nearest larger one. failing that it'll look for the nearest smaller one.
 */

function select_exact_or_closest_product_size(site, size, debug = false) {
  let unit_size = document.querySelector(".unit-size");
  let sizes = new Array();
  let type;

  // determine type of storage. switch used in case we need to
  // expand this functionality in the future, e.g. to containers
  switch (size.slice(-1)) {
    case "L":
      type = "locker";
      break;
    case "C":
      type = "container";
      break;
    default:
      type = "storageroom";
      break;
  }
  if (debug) {
    console.log("Type:", type);
  }

  // need to ensure size is numeric, else it causes issues
  // size = parseInt(size);

  // loop through available sizes
  for (let this_size of unit_size.querySelectorAll(".unit-size__main-slider__carousel-cell")) {
    sizes.push({
      quote_product: this_size.dataset.forSize,
      sizecode: this_size.dataset.sizecode,
      sites: this_size.dataset.sites != null ? this_size.dataset.sites.trim() : "clickandstore",
    });
  }

  if (debug) {
    console.log("All: ");
    console.log(sizes);
  }

  // filter out sizes that don't match this site
  sizes = sizes.filter((size) => size.sites.includes(site));

  if (debug) {
    console.log("Filtered via relevant site: ");
    console.log(sizes);
  }

  // filter out irrelevant types
  if (type === "locker") {
    sizes = sizes.filter((size) => size.sizecode.slice(-1) === "L");
  } else if (type === "container") {
    sizes = sizes.filter((size) => size.sizecode.slice(-1) === "C");
  } else {
    sizes = sizes.filter((size) => size.sizecode.match(/^\d+$/));
  }

  if (debug) {
    console.log("Filtered out irrelevant types: ");
    console.log(sizes);
  }

  // filter out budget units
  sizes = sizes.filter((size) => isNaN(size.sizecode) || size.sizecode % 5 === 0);

  if (debug) {
    console.log("Filtered out budget units: ");
    console.log(sizes);

    console.log("Looking for size: ");
    console.log(size);
  }

  // look for a size that matches or is larger than this size. as we've already
  // filtered out the relevant type, we can convert everything to integers
  let match = sizes.find((item) => parseInt(item.sizecode) >= parseInt(size));
  match = match != null ? match : sizes.reverse().find((item) => parseInt(item.sizecode) < parseInt(size));

  // if match found
  if (match != null) {
    if (debug) {
      console.log("Match found: ");
      console.log(match);
    }

    // select size
    let selected_sizecode = $('.unit-size__main-slider__carousel-cell[data-sizecode="' + match.sizecode + '"');
    $(".unit-size__main-slider").flickity("select", selected_sizecode.index(), false, true);
    $(".unit-size__range-slider").val(selected_sizecode.index()).change();
  }

  return sizes;
}
